import {POIUtility} from "../models/POI";
import { i18n } from "../../i18n";

export function createIndividualWaypointGeoJsonObjectHelper(clientId: string, e: any, poiType: POIUtility) {
  return {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "properties": {
        "title": i18n.global.t('utils.create_individual_waypoint_geo_json_object_helper.custom_waypoint'),
        "clientId": clientId,
        "iconName": poiType.getSpriteSheetWaypointIcon(),
        "type": poiType.poi,
        "isWaypoint": true,
      },
      "geometry": {
        "type": "Point",
        "coordinates": [e.lng, e.lat]
      }
    }]
  }
}
